import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import axios from 'axios';
import styles from '../styles/AdminDashboard.module.css';

const AdminDashboard = () => {
    const navigate = useNavigate();
    const { user } = useUser();
    const [stats, setStats] = useState({
        totalJobs: 0,
        totalApplications: 0,
        totalUsers: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/jobs/dashboard-stats`, {
                    withCredentials: true
                });
                setStats(response.data);
            } catch (error) {
                console.error('Error fetching dashboard stats:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, []);

    const handlePostJobClick = () => {
        navigate('/admin/post-job');
    };

    const handleViewJobsClick = () => {
        navigate('/admin/all-jobs');
    };

    return (
        <div className={styles.dashboardContainer}>
            <h1 className={styles.title}>Admin Dashboard</h1>
            <p className={styles.welcomeMessage}>Welcome, {user?.firstName || 'Admin'}!</p>
            
            <div className={styles.actionsContainer}>
                <button className={styles.actionButton} onClick={handlePostJobClick}>Post a Job</button>
                <button className={styles.actionButton} onClick={handleViewJobsClick}>View Jobs</button>
                <button className={styles.actionButton}>View Applications</button>
                <button className={styles.actionButton}>Manage Users</button>
            </div>

            <div className={styles.statsContainer}>
                <h2 className={styles.sectionTitle}>Dashboard Stats</h2>
                {loading ? (
                    <p>Loading stats...</p>
                ) : (
                    <ul className={styles.statsList}>
                        <li>Total Jobs Posted: {stats.totalJobs}</li>
                        <li>Total Applications: {stats.totalApplications}</li>
                        <li>Active Users: {stats.totalUsers}</li>
                    </ul>
                )}
            </div>

            <div className={styles.recentActivitiesContainer}>
                <h2 className={styles.sectionTitle}>Recent Activities</h2>
                <ul className={styles.activitiesList}>
                    <li>John Doe applied for Project Manager Intern</li>
                    <li>Jane Smith posted a new job for Software Engineer</li>
                    <li>Admin updated the job description for Sales Representative</li>
                </ul>
            </div>
        </div>
    );
};

export default AdminDashboard;
